<!-- Search -->
<div class="search-row">
    <mat-form-field appearance="outline" class="search-field">
        <mat-label>ALSDE ID</mat-label>
        <input matInput [(ngModel)]="formAlsdeId" (keydown)="onKeydown($event)" placeholder="Enter ALSDE ID">
    </mat-form-field>
    <button mat-flat-button color="primary" (click)="searchUser()" [disabled]="!formAlsdeId || isLoadingUser">
        <mat-icon *ngIf="!isLoadingUser">search</mat-icon>
        <mat-spinner *ngIf="isLoadingUser" diameter="20"></mat-spinner>
        Search
    </button>
</div>

<!-- Error -->
<div *ngIf="searchError" class="alert alert-danger d-flex align-items-start mt-2 mb-0" role="alert">
    <mat-icon class="me-2 flex-shrink-0" style="color: #c62828; font-size: 18px; width: 18px; height: 18px;">error_outline</mat-icon>
    <span style="white-space: pre-line; text-align: left;">{{searchError}}</span>
</div>

<!-- Person Summary -->
<div class="mt-3">
    <app-person-summary-card [person]="person"></app-person-summary-card>
</div>

<!-- Certificates -->
<div *ngIf="person?.demographics?.alsdeId" class="certs-section mt-3">
    <app-cert-summary-list [certificates]="certificates" [isLoading]="isLoadingCerts"></app-cert-summary-list>
</div>
